import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/hero"
import Cabins from "../components/cabins"
import About from "../components/Sections/About"
import "bootstrap/dist/css/bootstrap.min.css"

const IndexPage = () => {
  return (
    <Layout>
      <SEO
        title="Tofino Cabin Rentals"
        description="Gold Coast Retreat offers Tofino vacation cabin rentals nestled in a rainforest clearing, a one-minute walk from Chesterman Beach on Vancouver Island's west coast."
      />
      <Hero />
      <Cabins heading="Tofino cabin rentals at chesterman beach" />
      <About />
    </Layout>
  )
}

export default IndexPage
